import axios from 'axios'
import {
    message,
    Modal
} from 'ant-design-vue';
import {
    baseURL
} from '@/config'
// import storage from '@/utils/storage'
import store from '@/store'

import { getCookie, clearCookie } from '@/utils'

const api = axios.create({
    baseURL,
    timeout: 30000
})

api.interceptors.request.use(async config => {
    const token = getCookie('token') || false
    if (token) {
        config.headers['authorization'] = token
    }
    console.info('Api.config:', config)
    return config
})

api.interceptors.response.use((response = {}) => {
    console.info('Api.success:', response)
    let responseData = response && response.data || {}
    if (responseData.code >= 200 && responseData.code < 300) {
        return responseData
    } else if (responseData.code == 401 || responseData.code == 400) {
        clearCookie()
        store.dispatch('setToken', '')
        location.replace('/')
        return Promise.reject(false)
    } else {
        message.error(responseData.msg)
        return Promise.reject(false)
    }
}, error => {
    if (error.response.status == 401) {
        clearCookie()
        store.dispatch('setToken', '')
        location.replace('/')
    } else {
        console.info('Api.error:', error, error.response)
        const errorCode = error && error.response && error.response.status || -1
        Modal.warning({
            content: 'unknown error！' + errorCode
        })
    }
    return false
})

export default api